module.exports = __webpack_public_path__ + "static/img/erm.47cf006.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/erm.jpg
// module id = 3Zeg
// module chunks = 1